import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaundryMachine2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "laundry-machine-2" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 2.25,
			y: .75,
			width: 19.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 3.75,
			x2: 8.25,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 6.75,
			x2: 21.75,
			y2: 6.75
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 15,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18,3.375a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,3.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M13.5,3.375a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9.75,15A2.25,2.25,0,0,1,12,12.75"
		})
	]
});
export default SvgLaundryMachine2;
